export default "__VITE_ASSET__ma4er$1v__"